import * as types from './types';

export const loginUserRequest = (payload) => ({
  type: types.USER_LOGIN_REQUEST,
  payload,
});

export const resetSignInErrors = () => ({
  type: types.USER_LOGIN_FAILURE,
  payload: null,
});

export const resetPasswordResetErrors = () => ({
  type: types.USER_RESET_PASSWORD_FAILURE,
  payload: null,
});

export const resetPassword = payload => ({
  type: types.USER_RESET_PASSWORD_REQUEST,
  payload,
});

export const sendResetPassword = payload => ({
  type: types.USER_SEND_RESET_PASSWORD_REQUEST,
  payload,
});

export const getAuthUserAction = (payload) => ({
  type: types.USER_GET_AUTH_USER,
  payload,
});

export const setUserRole = payload => ({
  type: types.SET_USER_ROLE,
  payload,
});

export const signupRequest = (payload) => ({
  type: types.USER_SIGNUP_REQUEST,
  payload,
});

export const signupSuccess = (payload) => ({
  type: types.USER_SIGNUP_SUCCESS,
  payload,
});

export const signupFailure = (payload) => ({
  type: types.USER_SIGNUP_FAILURE,
  payload,
});

export const confirmPhoneRequest = (payload) => ({
  type: types.USER_CONFIRM_PHONE_REQUEST,
  payload,
});

export const confirmPhoneSuccess = (payload) => ({
  type: types.USER_CONFIRM_PHONE_SUCCESS,
  payload,
});

export const confirmPhoneFailure = (payload) => ({
  type: types.USER_CONFIRM_PHONE_FAILURE,
  payload,
});

export const resendCodePhoneRequest = (payload) => ({
  type: types.USER_RESEND_PHONE_CODE_REQUEST,
  payload,
});

export const resendCodePhoneSuccess = (payload) => ({
  type: types.USER_RESEND_PHONE_CODE_SUCCESS,
  payload,
});

export const resendCodePhoneFailure = (payload) => ({
  type: types.USER_RESEND_PHONE_CODE_FAILURE,
  payload,
});

export const changeEmailRequest = (payload) => ({
  type: types.USER_CHANGE_EMAIL_REQUEST,
  payload,
});

export const changeEmailSuccess = (payload) => ({
  type: types.USER_CHANGE_EMAIL_SUCCESS,
  payload,
});

export const changeEmailFailure = (payload) => ({
  type: types.USER_CHANGE_EMAIL_FAILURE,
  payload,
});

export const changePhoneRequest = (payload) => ({
  type: types.USER_CHANGE_PHONE_REQUEST,
  payload,
});

export const changePhoneSuccess = (payload) => ({
  type: types.USER_CHANGE_PHONE_SUCCESS,
  payload,
});

export const changePhoneFailure = (payload) => ({
  type: types.USER_CHANGE_PHONE_FAILURE,
  payload,
});

export const confirmEmailRequest = (payload) => ({
  type: types.USER_CONFIRM_EMAIL_REQUEST,
  payload,
});

export const confirmEmailSuccess = (payload) => ({
  type: types.USER_CONFIRM_EMAIL_SUCCESS,
  payload,
});

export const confirmEmailFailure = (payload) => ({
  type: types.USER_CONFIRM_EMAIL_FAILURE,
  payload,
});

export const resendCodeEmailRequest = (payload) => ({
  type: types.USER_RESEND_EMAIL_CODE_REQUEST,
  payload,
});

export const resendCodeEmailSuccess = (payload) => ({
  type: types.USER_RESEND_EMAIL_CODE_SUCCESS,
  payload,
});

export const resendCodeEmailFailure = (payload) => ({
  type: types.USER_RESEND_EMAIL_CODE_FAILURE,
  payload,
});